import Values from './ValuesForAnswerToConditionTypes'

export default {

    UserRights: [
        { Id: 0, Text: "Неизвестен" },
		{ Id: 1, Text: "Администратор" },
		{ Id: 2, Text: "Аудитор" },
        { Id: 3, Text: "Инспектор" },
        { Id: 4, Text: "Сервис" },
		{ Id: 5, Text: "Не зарегистрирован в DAX" }
    ],

    UserStatus: [
        { Id: 0, Text: "Неизвестен" },
        { Id: 1, Text: "Активный" },
        { Id: 2, Text: "Архивный" },
    ],

    UserType : [
		{Id: 1, Text: 'Внутренний'},
		{Id: 5, Text: 'Внешний'}
    ],
    
    ActivityAuditStatus: [
		{Id: 1, Text: "Активный"},
		{Id: 2, Text: "Неактивный"}
    ],
    
    AuditType: [
        {Id: 1, Text: "Полевая активность"},
        {Id: 2, Text: "Горячая линия"},
        {Id: 3, Text: "Я-инспектор"}        
    ],

    AuditStatus: [
        {Id: 1, Text: "В работе"},
        {Id: 2, Text: "Завершен"},
        {Id: 3, Text: "Отправлен"},
        {Id: 4, Text: "Удален"}        
    ],
   //-----------ВОПРОСЫ------------------
    QuestionTypes: [
        { Id: 1, Text: 'Главный' },
		{ Id: 2, Text: 'Подчиненный' }
    ],

    PlaceTypes: [
		{ Id: 1, Text: 'Начало аудита' },
        { Id: 2, Text: 'Анкета' },		
		{ Id: 3, Text: 'Конец аудита' },
		{ Id: 4, Text: 'Вкладка Магнит' }
    ],

	AnswerTypesDax : [
		{ Id: 1, Text: 'Целое число' },
        { Id: 2, Text: 'Произвольный ответ' },		
		{ Id: 3, Text: 'Одиночный выбор' },
		{ Id: 4, Text: 'Множественный выбор' },
		{ Id: 5, Text: '' },
        { Id: 6, Text: 'Да/Нет' },		
		{ Id: 7, Text: 'Контакт' },
		{ Id: 8, Text: '' },
		{ Id: 9, Text: '' },
		{ Id: 10, Text: '' }
	],

    AnswerTypes: [
        { Id: 1, Text: 'Произвольный ответ' },

		{ Id: 10, Text: 'Целое число' },
		{ Id: 11, Text: 'Число' },
		{ Id: 12, Text: 'Процент' },

		{ Id: 20, Text: 'Одиночный выбор' },
		{ Id: 21, Text: 'Множественный выбор' },
		{ Id: 22, Text: 'Выбор из маленького списка' },
		{ Id: 23, Text: 'Проблема торговых точек' },
		{ Id: 24, Text: 'Проблема товаров' },

		{ Id: 30, Text: 'Выбор контакта' },

		{ Id: 40, Text: 'Да/Нет' },

		{ Id: 101, Text: 'MML SKU МАЙ в Торговой точке, кол-во(ЧАЙ+КОФЕ)' },
		{ Id: 102, Text: 'AEP (Чай+Кофе)' },
		{ Id: 103, Text: 'Фактическое количество SKU Май Фудс согласно рейтинг листа(ЧАЙ+КОФЕ)' },
		{ Id: 104, Text: '2 Фактическое количество SKU Май Фудс согласно рейтинг листа' },
		{ Id: 105, Text: 'Сигнал Магнита' },

		{ Id: 131, Text: 'MML SKU МАЙ в Торговой точке, кол-во(ЧАЙ)' },
		{ Id: 132, Text: 'Фактическое количество SKU Май Фудс согласно рейтинг листа(ЧАЙ)' },
		{ Id: 133, Text: 'AEP (Чай)' },

		{ Id: 161, Text: 'MML SKU МАЙ в Торговой точке, кол-во(КОФЕ)' },
		{ Id: 162, Text: 'Фактическое количество SKU Май Фудс согласно рейтинг листа(КОФЕ)' },
		{ Id: 163, Text: 'AEP (Кофе)' },
    { Id: 170, Text: 'AEP (ТМА)' },
    { Id: 171, Text: 'TMA' },
    ],

    ConditionTypes: [
        { Id: 1, Text: 'Любой текст' },
		{ Id: 2, Text: 'Текст совпадает с' },
		{ Id: 10, Text: 'Число равно' },
		{ Id: 11, Text: 'Число больше' },
		{ Id: 12, Text: 'Число меньше' },
		{ Id: 20, Text: 'Ответ выбран' },
		{ Id: 21, Text: 'Ответ не выбран' },
		{ Id: 30, Text: 'Контакт выбран' },
		{ Id: 40, Text: 'Выбрано да' },
		{ Id: 41, Text: 'Выбрано нет' },
		{ Id: 100, Text: 'AEP/SKU выбран' },
		{ Id: 101, Text: 'AEP/SKU не выбран' }
    ],

    TradePointConditionTypes: [
        { Id: 200, Text: "Торговая точка является сетью" },
		{ Id: 201, Text: "У торговой точки указанный тип" },
		{ Id: 202, Text: "Торговая точка находится в филиале" },
		{ Id: 203, Text: "Торговая точка относится к сети" },
		{ Id: 204, Text: "Торговая точка не относится к сети" },
		{ Id: 205, Text: "Торговая точка содержит ТМА"},
		{ Id: 206, Text: "Торговая точка находится в регионе" }
    ],

    VisibleConditionTypes: [
        { Id: 0, Text: 'Не отображать если' },
		{ Id: 1, Text: 'Отображать если' }
	],
	

    AnswerToConditionTypes: new Map ([
        [ 1, Values.TextTypes ],

		[ 10, Values.NumberTypes ],
		[ 11, Values.NumberTypes ],
		[ 12, Values.NumberTypes ],

		[ 20, Values.SelectTypes ],
		[ 21, Values.SelectTypes ],
		[ 22, Values.SelectTypes ],

		[ 30, Values.ContactTypes ],

		[ 40, Values.BoolTypes ],

		[ 101, Values.AepTypes ],
		[ 102, Values.AepTypes ],
		[ 103, Values.AepTypes ],
		[ 104, Values.AepTypes ],
		[ 105, Values.AepTypes ],
		[ 131, Values.AepTypes ],
		[ 132, Values.AepTypes ],
		[ 133, Values.AepTypes ],
		[ 161, Values.AepTypes ],
		[ 162, Values.AepTypes ],
		[ 163, Values.AepTypes ],
    [ 170, Values.AepTypes],
    [ 171, Values.AepTypes]

    ]),

    RelationTypes: [
        { Id: 1, Text: 'От ответа на вопрос' },
		{ Id: 2, Text: 'От торговой точки' }
    ],
	
	TradePointTypes: [
		{ Text: 'ALC' },
		{ Text: 'CST' },
		{ Text: 'DC' },
		{ Text: 'DCH' },
		{ Text: 'EDU' },
		{ Text: 'ES' },
		{ Text: 'FFD' },
		{ Text: 'GAS' },
		{ Text: 'GPM' },
		{ Text: 'GS' },
		{ Text: 'GWS' },
		{ Text: 'HD' },
		{ Text: 'HOT' },
		{ Text: 'KET' },
		{ Text: 'NAR' },
		{ Text: 'NFD' },
		{ Text: 'PAL' },
		{ Text: 'PAV' },
		{ Text: 'PSPM' },
		{ Text: 'PW' },
		{ Text: 'RMP' },
		{ Text: 'SC' },
		{ Text: 'SDIS' },
		{ Text: 'SPM' },
		{ Text: 'SPT' },
		{ Text: 'WHS' },
		{ Text: 'DIS' },
		{ Text: 'STN' },
		{ Text: 'SPR' },
		{ Text: 'CF' },
		{ Text: 'BK' },
		{ Text: 'RES' },
		{ Text: 'CAN' },
		{ Text: 'PZZ' },
		{ Text: 'GST' },
	],

	ResultAuditType: [
		{ Id: 1, Text: 'Форма' },
		{ Id: 2, Text: 'ShortCall' },
		{ Id: 3, Text: 'Инспектор' }
	],

	SegmentCodes: [
        { Id: 0, Text: 'Неизвестен' },
        { Id: 1, Text: 'S0' },
        { Id: 2, Text: 'S1' },
        { Id: 3, Text: 'S2' },
		{ Id: 4, Text: 'S3' },
		{ Id: 5, Text: 'S4' },
		{ Id: 6, Text: 'S5' },
		{ Id: 7, Text: '<50' },
        { Id: 8, Text: '>=50' }
	]
}